module.exports = __webpack_public_path__ + "static/img/postbox.60725d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/postbox.svg
// module id = UunK
// module chunks = 0